import { localStorageColorSchemeManager, MantineColorSchemeManager } from "@mantine/core";

/**
 * Mantine's localStorage colour scheme manager, without the write-back when another tab changes the scheme. Mantine
 * applies a storage event through setColorScheme, which saves the value again. If the user toggles quickly, a tab can
 * save a value that is already stale, which fires a storage event in the other tab, and the tabs flip each other forever.
 * @returns A colour scheme manager for MantineProvider.
 */
export const createColorSchemeManager = (): MantineColorSchemeManager => {
    const manager = localStorageColorSchemeManager();
    let isApplyingStorageEvent = false;

    return {
        ...manager,
        set: (value) => {
            // The tab that sent the storage event has already saved this value.
            if (!isApplyingStorageEvent) {
                manager.set(value);
            }
        },
        subscribe: (onUpdate) =>
            manager.subscribe((value) => {
                isApplyingStorageEvent = true;
                try {
                    onUpdate(value);
                } finally {
                    isApplyingStorageEvent = false;
                }
            }),
    };
};
